export default "__VITE_ASSET__026nY7gv__"